import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@mui/styles';
import { useMediaQuery, Grid, Typography } from '@mui/material';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';

const useStyles = makeStyles(() => ({
  image: {
    maxWidth: 420,
  },
}));

const Story = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <Grid
        container
        justify="space-between"
        spacing={isMd ? 4 : 2}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          justify="flex-start"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <div>
            <SectionHeader
              title="About Mperito"
              subtitle=" "
              align="left"
              disableGutter
              subtitleProps={{
                color: 'textPrimary',
                variant: 'body1',
              }}
            />
            <Typography
              variant="body1"
              color="textPrimary"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }} 
              className=""
            >
              The world of commerce is evolving faster than ever, with online shopping and instant delivery platforms becoming the new norm. This shift presents a powerful opportunity for every business to grow beyond boundaries and connect with their customers like never before.
            </Typography>
            <Typography
              variant="body1"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }} 
              color="textPrimary"
              className=""
            >
              While a few large platforms have dominated the market, they often overshadow the unique identity of individual sellers. Yet, many physical stores have already spent years building strong relationships and trust with their customers—brick by brick, one loyal customer at a time.
            </Typography>
            <Typography
              variant="body1"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }} 
              color="textPrimary"
              className=""
            >
              Now is the perfect time to take that success online.
            </Typography>
            <Typography
              variant="body1"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }} 
              color="textPrimary"
              className=""
            >
              At <strong>MPERITO</strong>, we believe that every business deserves the chance to shine on its own terms. Our platform is designed to make going online simple, quick, and effective—empowering sellers to reach their customers both online and offline, under their <strong>own brand name</strong>.
            </Typography>
            <Typography
              variant="body1"
              align="justify"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }} 
              color="textPrimary"
              className=""
            >
              Whether you're a legacy store or a new venture, MPERITO helps you extend your reach, grow your brand visibility, and offer your customers the convenience they expect—without losing the personal touch that makes your business special.
            </Typography>
            <Typography
              variant="h6"
              sx={{ display: 'block', marginBottom: theme => theme.spacing(2) }} 
              color="textPrimary"
              className=""
            >
              Start your digital journey with MPERITO today—because <strong>Your brand deserves the spotlight</strong>.
            </Typography>
          </div>
        </Grid>
        <Grid
          item
          container
          justify={isMd ? 'flex-end' : 'flex-start'}
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Image
            src="/assets/images/about/story.png"
            alt="Our story"
            className={classes.image}
          />
        </Grid>
      </Grid>
    </div>
  );
};

Story.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Story;
